import { getState, patchState, signalStore, withMethods, withState } from "@ngrx/signals";
import { PayerConfigItem, PayerRiskAdjustmentPolicy } from "../models/payer-config-item"
import { PayerConfigService } from "../services/payer/payer-config.service";
import { inject } from "@angular/core";
import { PayerConfigQuery } from "../models/payer-config-query";
import { PayerConfigQueryResult } from "../models/payer-config-query-result";
import { map } from "rxjs/operators";

// The payer being added/edited and its service year policies, shared by the Add/Update Payer dialog
// and the risk policy dialog it (or the Payer Configuration page) opens. App-wide; whoever opens a
// dialog sets the payer first, and clears it when done. The page list itself lives in
// PayerConfigurationStore.

type PayerEditState = {
    currentPayerItem: PayerConfigItem;
    riskAdjustmentPolicies: PayerRiskAdjustmentPolicy[];
}

const initialState: PayerEditState = {
    currentPayerItem: new PayerConfigItem(),
    riskAdjustmentPolicies: [],
}

export const PayerEditStore = signalStore(
    { providedIn: 'root' },
    withState(initialState),
    withMethods((store, configService = inject(PayerConfigService)) => ({
        setCurrentPayerItem(input: PayerConfigItem) {
            return new Promise<void>((resolve) => {
                patchState(store, { currentPayerItem: input });
                resolve();
            });
        },
        // Re-reads the payer (e.g. after a save) from the config list.
        setCurrentPayerItemById(id: number) {
            const query = new PayerConfigQuery();
            query.PayerIDs = id + "";
            return configService.getPayerConfigs(query).pipe(
                map((result: PayerConfigQueryResult) => {
                    patchState(store, { currentPayerItem: result.Items[0] });
                })
            )
        },
        // Loads the current payer's service year policies.
        setRiskAdjustmentPolicies(): void {
            const state = getState(store);
            configService.getPayerRiskPolicies(state.currentPayerItem.PayerID).subscribe((result) => {
                patchState(store, { riskAdjustmentPolicies: result });
            });
        },
        clearState() {
            patchState(store, initialState);
        },
    })),
);
